import ClientList from "./ClientList"

export default  ClientList;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientList/index.js